export function filtruotiMain(ats = [], filterMain = {}, setTvarkyta, year, urlFilters = {}) {
    // Handle empty or invalid input
    if (!ats) {
        setTvarkyta([]);
        return true;
    }

    // Convert object to array if needed
    const atsArray = Array.isArray(ats) ? ats : Object.values(ats);
    
    if (atsArray.length === 0) {
        setTvarkyta([]);
        return true;
    }


    const filtruota = atsArray.filter(atsakymas => {
        // Parse answer data
        let answerData;
        try {
            answerData = typeof atsakymas.attributes.atsakymai === 'string' 
                ? JSON.parse(atsakymas.attributes.atsakymai)
                : atsakymas.attributes.atsakymai;
        } catch (error) {
            return false;
        }

        if (!answerData) {
            return false;
        }

        // Check form type (Darbuotojo forma / Įmonės forma)
        if (filterMain.kasPildo) {
            const formType = atsakymas.attributes.kasPildo;
            // Skip if form type doesn't match or is undefined
            if (!formType || formType !== filterMain.kasPildo) {
                return false;
            }
        }

        // Company filtering - different logic for different form types
        if (filterMain.imonesPavadinimas || filterMain.imone) {
            const companyName = filterMain.imonesPavadinimas || filterMain.imone;
            
            const answersCompany = atsakymas.attributes.imonesPavadinimas || atsakymas.attributes.imone;
            
            // Check company name match for both form types
            if (!answersCompany || companyName !== answersCompany) {
                return false;
            }
        }

        // Check year if provided
        if (year && !atsakymas.attributes.uzpildymoData?.includes(year.toString())) {
            return false;
        }

        // Check any additional filters from filterMain
        for (const [key, value] of Object.entries(filterMain)) {
            // Skip already checked filters
            if (['kasPildo', 'imonesPavadinimas', 'imone'].includes(key)) continue;
            
            // Skip empty filters
            if (!value || value === 'All') continue;

            const attrValue = answerData[key] || atsakymas.attributes[key];
            
            // Skip if attribute doesn't exist or doesn't match
            if (!attrValue || attrValue !== value) {
                return false;
            }
        }

        // Check URL filters - only for "Darbuotojo forma"
        if (filterMain.kasPildo === "Darbuotojo forma" && Object.keys(urlFilters).length > 0) {

            // Check URL filters
            for (const [key, values] of Object.entries(urlFilters)) {
                if (!values || values.length === 0) continue;

                // Try to find the value in answer data
                const questionKey = Object.keys(answerData).find(k => 
                    k.toLowerCase() === key.toLowerCase() ||
                    k.toLowerCase().includes(key.toLowerCase())
                );

                if (!questionKey) {
                    return false;
                }

                const answerValue = answerData[questionKey];
                if (!answerValue) {
                    return false;
                }

                // Handle array of values
                if (Array.isArray(values)) {
                    // Convert answer value to array if it's not already
                    const answerValues = Array.isArray(answerValue) ? answerValue : [answerValue];
                    // Check if any of the filter values match any of the answer values
                    const hasMatch = values.some(value => 
                        answerValues.some(answer => 
                            answer.toString().toLowerCase() === value.toString().toLowerCase()
                        )
                    );
                    if (!hasMatch) {
                        return false;
                    }
                }
                // Handle single value
                else {
                    if (answerValue.toString().toLowerCase() !== values.toString().toLowerCase()) {
                        return false;
                    }
                }
            }
        }

        return true;
    });


    setTvarkyta(filtruota);
    return true;
}
